import { mittInstance } from '@/constants/mitt-instance';
import { useCartContext } from '@/context/cart';
import { useLazyQuery } from '@apollo/client';
import { usePathname } from 'next/navigation';
import { useEffect, useState } from 'react';

/**
 * Routes to hide the mini cart on.
 */
const DENIED_MINI_CART_ROUTES = ['/checkout'];

export const useCartTrigger = props => {
  const {
    queries: { getItemCountQuery },
  } = props;

  const [{ cartId }] = useCartContext();

  const pathname = usePathname();

  const [isHidden, setIsHidden] = useState(() => DENIED_MINI_CART_ROUTES.includes(pathname));

  const [runQuery, { data }] = useLazyQuery(getItemCountQuery, {
    fetchPolicy: 'cache-and-network',
    errorPolicy: 'all',
  });

  useEffect(() => {
    if (cartId) {
      runQuery({
        variables: {
          cartId,
        },
        context: {
          headers: {
            'X-Robots-Tag': 'noindex, nofollow',
          },
        },
      });
    }
  }, [cartId, runQuery]);

  useEffect(() => {
    const handler = () => {
      if (cartId) {
        runQuery({
          variables: {
            cartId,
          },
        });
      }
    };

    mittInstance.on('REFRESH_CART_TRIGGER_ITEM_COUNT', handler);

    return () => {
      mittInstance.off('REFRESH_CART_TRIGGER_ITEM_COUNT', handler);
    };
  }, [cartId, runQuery]);

  const itemCount = data?.cart?.total_quantity || 0;

  useEffect(() => {
    setIsHidden(DENIED_MINI_CART_ROUTES.includes(location.pathname));
  }, [pathname]);

  return {
    itemCount,
    hideCartTrigger: isHidden,
  };
};
